import "reflect-metadata";
import {inject, injectable} from "inversify";
import {CompanyEntity} from "@dropDesk/domain/entities/company/company.entity";
import {PanelAdmRepository} from "@dropDesk/domain/repositories/panel_adm/panel_adm.repository";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";

@injectable()
export class GetCompanyBySearchPanelUseCase {
  private _repository: PanelAdmRepository;

  constructor(@inject(PanelAdmRepository) repository: PanelAdmRepository) {
    this._repository = repository;
  }

  public call(search: string): Promise<{company: CompanyEntity, user:UserEntity}> {
    return this._repository.getCompanyBySearch(search);
  }
}

